// packages/preferences/src/store/selectors.ts
import deprecated from "@wordpress/deprecated";
var withDeprecatedKeys = (originalGet) => (state, scope, name) => {
  const settingsToMoveToCore = [
    "allowRightClickOverrides",
    "distractionFree",
    "editorMode",
    "fixedToolbar",
    "focusMode",
    "hiddenBlockTypes",
    "inactivePanels",
    "keepCaretInsideBlock",
    "mostUsedBlocks",
    "openPanels",
    "showBlockBreadcrumbs",
    "showIconLabels",
    "showListViewByDefault",
    "isPublishSidebarEnabled",
    "isComplementaryAreaVisible",
    "pinnedItems"
  ];
  if (settingsToMoveToCore.includes(name) && ["core/edit-post", "core/edit-site"].includes(scope)) {
    deprecated(
      `wp.data.select( 'core/preferences' ).get( '${scope}', '${name}' )`,
      {
        since: "6.5",
        alternative: `wp.data.select( 'core/preferences' ).get( 'core', '${name}' )`
      }
    );
    return originalGet(state, "core", name);
  }
  return originalGet(state, scope, name);
};
var get = withDeprecatedKeys(
  (state, scope, name) => {
    const value = state.preferences[scope]?.[name];
    return value !== void 0 ? value : state.defaults[scope]?.[name];
  }
);
export {
  get
};
//# sourceMappingURL=selectors.mjs.map
